module.exports = __webpack_public_path__ + "static/media/cloud.608ccc6c.jpg";